import { AppointmentSchedulingConfiguration } from '../../config/appointment_scheduling_configuration';
import { AppointmentButtonServant } from '../../servants/appointment_button_servant';

export class AppointmentFooterButtonController {
  constructor(
    private ngAppointmentButtonServant: AppointmentButtonServant,
    private ngAppointmentSchedulingConfiguration: AppointmentSchedulingConfiguration
  ) {}
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-appointments/src/components/appointment_footer_button/appointment_footer_button.ts